var map = {
	"./IMG_2199.JPG": 6687,
	"./IMG_2203.JPG": 2849,
	"./IMG_2206.JPG": 1696,
	"./IMG_2209.JPG": 4347,
	"./IMG_2213.JPG": 3522
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8690;